<template>
  <div id="commonHeader">
    <div class="text" @click="to">
      <p class="textDown" v-if="$route.name === 'RepayMethod'">
        After downloading the APP, <br> you only need to repay
        <span>₱ {{ amount }}</span>
      </p>
      <p class="textDown" v-else>
        <span>Download</span> the app and <br />
        get your <span>2nd</span> installment
        <span>waived.</span>
      </p>
    </div>
    <div class="right breathe" @click="to">
      <div class="time" v-if="showTime">
        <p>{{ formattedTime }}</p>
      </div>
      <div class="addBtn">
        <p>Get APP</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonHeader',
  data () {
    return {
      remainingSeconds: 2 * 3600 + 59 * 60 + 59,
      timer: null,
      showTime: true,
      amount: localStorage.getItem('dueAmount') || ''
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'RepayMethod') {
        this.amount = localStorage.getItem('dueAmount') || ''
      }
    }
  },
  computed: {
    formattedTime () {
      const hours = Math.floor(this.remainingSeconds / 3600)
      const minutes = Math.floor((this.remainingSeconds % 3600) / 60)
      const seconds = this.remainingSeconds % 60
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0'
      )}:${String(seconds).padStart(2, '0')}`
    }
  },
  mounted () {
    this.startCountdown()
  },
  beforeUnmount () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    startCountdown () {
      this.timer = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--
        } else {
          clearInterval(this.timer)
          this.showTime = false
        }
      }, 1000)
    },
    to () {
      this.$openLinkInNewWindow()
    }
  }
}
</script>

<style scoped lang="less">
#commonHeader {
  z-index: 99;
  position: fixed;
  background-image: url("../assets/headerBg.png");
  background-size: cover;
  background-repeat: no-repeat;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 12px;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  height: 75px;
  padding: 7px 0;
  .text {
    text-align: left;
    font-size: 12px;
    color: #0c8027;
    width: 186px;
    margin-left: 90px;
    margin-right: 9px;
    span {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .textDown {
    width: 200px;
  }
  .addBtn {
    background: #0c8027;
    border-radius: 30px;
    padding: 7px 16px;
  }
  .right {
    position: relative;
  }
  .time {
    background-image: url("~@/assets/guideTimeBg.png");
    width: 60px;
    height: 18px;
    background-size: 60px 18px;
    background-repeat: no-repeat;
    position: absolute;
    top: -15px;
    right: 3%;
    p {
      font-size: 9px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      flex-direction: column;
      margin-left: 5px;
      padding-top: 1px;
    }
  }
  .breathe {
    animation: btnSize 2s infinite;
    animation-delay: 1s;
  }
  @keyframes btnSize {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
